export const SCAN_QR_CODE = "/";
export const ORDER_ROOT = "/:barLocator";
export const CREATE_ORDER = `${ORDER_ROOT}/:orderName*`;
export const VIEW_ORDER = `${ORDER_ROOT}/orders/:orderId`;
